import { useSnapshot } from "valtio";

import { state } from "./State";

export const useSnapshotState = () => {
  return useSnapshot(state);
};

export const useAnswerText = (questionId: number) => {
  const snapshot = useSnapshotState();
  return snapshot.answerTextMap.get(questionId) || "";
};
